import { AuthContext, AuthContextType } from 'provider/authContext';
import { useContext } from 'react';

export const useAuth = () => {
  return useContext<AuthContextType>(AuthContext);
};
